export default __webpack_public_path__ + "static/media/bridge.bab9cf1f.svg";